/**
 * A logger is injected into the Remix loader and action contexts by the server.
 *
 * Use this module if you want to create a logger directly. Loggers are cheap to
 * create and they work in both the frontend and backend.
 */
import os from "os";
import pino from "pino";

type LoggerOptions = Extract<pino.LoggerOptions, { name?: string }>;

export interface LoggerContext {
  logger: pino.Logger;
}

export const createLogger = (loggerOptions?: LoggerOptions) => {
  const isClientSide = typeof window !== "undefined";

  return pino({
    base: { hostname: isClientSide ? window.location.hostname : os.hostname }, // NOTE default includes PID which is not too useful for us
    browser: {
      disabled: process.env.NODE_ENV === "production",
    },
    ...loggerOptions,
  });
};

export const createLoggerOrChild = ({
  logger,
  name,
}: {
  logger?: pino.Logger;
  name: string;
}) => {
  return logger ? logger.child({ name }) : createLogger({ name });
};

export const logger = createLogger();
